import Alpine from 'alpinejs'

// import components
import './components/search'
import './components/transcript'
import './components/page-image'
import './components/annotation-selectors'
import './components/annotation-highlights'

// Start Alpine.js
window.Alpine = Alpine
document.addEventListener('DOMContentLoaded', () => {
  Alpine.start();
});